import React, { useEffect } from "react";

import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../../../../../components/Loader/Loader";
import {
  CustomerItemRate,
  CustomerProItemRate,
  CustomerSupplierProAcDetail,
} from "../../../../../Redux/Slice/Fas/Profile Analysis/Customer/CustomerSlice";
import { useTheme } from "../../../../../Themecontext/Themecontext";
export default function MonthlyItemRate({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { CustomerItemRatedata } = useSelector((state) => state.CustomerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  useEffect(() => {
    dispatch(CustomerItemRate());
    dispatch(
      CustomerProItemRate({
        Firm,
        Year: YearId,
        AcIDs: accountName.join(","),
        selectedIds: accountGroup.join(","),
        startDate: startDate,
        endDate: endDate,
      }),
    );
    dispatch(CustomerSupplierProAcDetail({ AcIDs: accountName }));
  }, [dispatch, Firm, YearId, accountName]);

  const getRows = CustomerItemRatedata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    ItemName: label.ItemName,
    AprRate: label.AprRate,
    MayRate: label.MayRate,
    JunRate: label.JunRate,
    JulRate: label.JulRate,
    AugRate: label.AugRate,
    SepRate: label.SepRate,
    OctRate: label.OctRate,
    NovRate: label.NovRate,
    DecRate: label.DecRate,
    JanRate: label.JanRate,
    FebRate: label.FebRate,
    MarRate: label.MarRate,
    Rate: label.Rate,
    HighRate: label.HighRate,
    LowRate: label.LowRate,
  }));

  const getColumns = [
    { label: "Chart", key: "charts", align: "center" },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Item Name",
      key: "ItemName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Avg Rate", key: "Rate", align: "right", format: "true" },
    { label: "High Rate", key: "HighRate", align: "right", format: "true" },
    { label: "low Rate", key: "LowRate", align: "right", format: "true" },
    { label: "Apr ", key: "AprRate", align: "right", format: "true" },
    { label: "May ", key: "MayRate", align: "right", format: "true" },
    { label: "Jun ", key: "JunRate", align: "right", format: "true" },
    { label: "Jul ", key: "JulRate", align: "right", format: "true" },
    { label: "Aug ", key: "AugRate", align: "right", format: "true" },
    { label: "Sep ", key: "SepRate", align: "right", format: "true" },
    { label: "Oct ", key: "OctRate", align: "right", format: "true" },
    { label: "Nov ", key: "NovRate", align: "right", format: "true" },
    { label: "Dec ", key: "DecRate", align: "right", format: "true" },
    { label: "Jan ", key: "JanRate", align: "right", format: "true" },
    { label: "Feb ", key: "FebRate", align: "right", format: "true" },
    { label: "Mar ", key: "MarRate", align: "right", format: "true" },
  ];

  if (CustomerItemRatedata === "no" || CustomerItemRatedata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            padding: "18px 22px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",  
            }}
          >
            MONTHLY ITEM RATE
          </h2>
        </div>
        <FASTable data={getRows} columns={getColumns} />
      </div>
    </div>
  );
}
